import { Show, SimpleShowLayout, TextField } from "react-admin";

const LocationShow = () =>(
    <Show>
        <SimpleShowLayout>
            <TextField source="location" label="Location" />
        </SimpleShowLayout>
    </Show>
);

export default LocationShow;